import React from 'react'
import Link from 'gatsby-link'
import css from 'emotion';
import styled from 'react-emotion';

const FooterContainer = styled.footer`
    background: ${props => !props.chapter ? "#222" : "transparent"};
    color: #e3cf34;
    text-align: center;
`

const Footer = (props) => (
    <FooterContainer chapter={props.chapter}>
        <div
        css={{
            margin: '0 auto',
            padding: '.5rem 0',
        }}
        >
            &copy; {new Date().getFullYear()} Hitchhiker's Guide to Javascript
        </div>
    </FooterContainer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer/index.js